<div class="page-print">
    <router-outlet></router-outlet>
</div>